import React from "react";

const Container = ({ children }) => {
  return <div className="max-w-6xl mx-auto sm:px-6 lg:px-8">{children}</div>;
};

export default Container;
